export const QA_NAME_REQUEST_PROFILE_PAGE = 'RequestProfile'

// Tab ids double as the backend counters section names
export const REQUEST_PROFILE_TAB_EMAILS = 'emails'

export const REQUEST_PROFILE_TAB_ACTIVITIES = 'activities'

export const REQUEST_PROFILE_TAB_INTERNAL_TASKS = 'checklists'

export const REQUEST_PROFILE_TAB_POSTS = 'posts'

export const REQUEST_PROFILE_TAB_CHATS = 'chats'

export const REQUEST_PROFILE_TAB_DOCUMENTS = 'documents'

export const REQUEST_PROFILE_TAB_ATTACHED_REQUESTS = 'related_requests'

export const REQUEST_PROFILE_TAB_DOC_FLOWS = 'document_staplings'

export const REQUEST_PROFILE_TAB_UPDATES = 'updates'
